<template>
  <div class="form-group">
    <label v-if="label" style="width: 100%">{{ label }}
      <span v-if="required" style="color: red;"> *</span>
      <span v-if="validation?.$error" style="color: red; padding-left: 10px;">{{ messages }}</span>
    </label>
    <textarea
        :value="modelValue"
        @input="handleInput"
        v-bind="$attrs"
        :style="inputStyle"
        :placeholder="placeholder"
        autocomplete="off"
        class="form-control"
        :class="{ 'is-invalid': validation?.$error }">
    </textarea>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  modelValue: {
    type: [ String, Number, null ],
    required: true,
  },
  label: {
    type: [ String, Boolean ],
    default: false,
  },
  placeholder: {
    type: [ String, Boolean ],
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  messages: {
    type: [ Object, String, Array ],
    default: () => ({}),
  },
  refProps: {
    type: [ Object, String ],
    default: () => ({}),
  },
  inputStyle: {
    type: Object,
  },
});

const emit           = defineEmits([ 'update:modelValue' ]);
const { modelValue } = toRefs(props);

const handleInput = (event) => {
  let inputValue = event.target.value;
  emit('update:modelValue', inputValue);
};

</script>

<style scoped>

</style>